import { Link } from "react-router-dom";
import { ArrowUpRight, ExternalLink } from "lucide-react";
import { blogPosts } from "@/data/blogPosts";

export default function Blog() {
  return (
    <div data-testid="blog-page">
      <section className="border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
          <span className="text-xs font-bold uppercase tracking-widest text-[#FF5A00]">Blog</span>
          <h1 className="font-heading font-extrabold tracking-tight leading-none text-4xl sm:text-5xl lg:text-6xl mt-3">
            Insights for <span className="text-[#FF5A00]">smarter</span> books.
          </h1>
          <p className="mt-6 text-base md:text-lg text-muted-foreground max-w-2xl leading-relaxed">
            Practical bookkeeping, accounting, AP and AR advice for US and Canadian business owners.
          </p>
          <a
            href="https://www.blogger.com/blog/posts/237350172922570442"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="blog-blogger-link"
            className="inline-flex items-center gap-2 border border-foreground font-bold text-sm px-6 py-3 mt-6 hover:bg-foreground hover:text-white transition-colors"
          >
            Read more on our Blogger page <ExternalLink size={15} />
          </a>
        </div>
      </section>

      <section>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogPosts.map((post) => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                data-testid={`blog-card-${post.slug}`}
                className="group border border-border bg-white hover-lift block"
              >
                <div className="overflow-hidden">
                  <img src={post.image} alt={post.title} className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-bold uppercase tracking-widest text-[#FF5A00]">{post.category}</span>
                    <ArrowUpRight size={16} className="text-muted-foreground group-hover:text-[#FF5A00] transition-colors" />
                  </div>
                  <h2 className="font-heading font-bold text-lg mt-3 leading-snug group-hover:text-[#FF5A00] transition-colors">{post.title}</h2>
                  <p className="text-sm text-muted-foreground mt-3 leading-relaxed line-clamp-2">{post.excerpt}</p>
                  <p className="text-xs text-muted-foreground mt-4">{post.date} · {post.readTime}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
